module.exports = __webpack_public_path__ + "static/media/smile-plus.b47af5e8.svg";